import React, { useEffect } from "react";
import { GrowthBook, GrowthBookProvider as GBProvider } from "@growthbook/growthbook-react";
import { getEnv } from "../EnvironmentTools";
import { getCurrentLanguage, getStoreId } from "../BasePathTools";
import { getTarget } from "./utils";
import { getAppVersion } from "../eventsBus";



export const GrowthBookProvider = ({ children }: { children: React.ReactNode }) => {
    const growthbook = new GrowthBook({
      apiHost: getEnv()?.growthBookHost,
      clientKey: getEnv()?.growthBookClientKey,
      decryptionKey: getEnv()?.growthBookDescriptionKey,
      enableDevMode: true,
    });

    useEffect(() => {
        growthbook.init({ streaming: true });
        growthbook.setAttributes({
            "storeId": getStoreId()?.toString(),
            "langCode": getCurrentLanguage(),
            "target": getTarget(),
            "version": getAppVersion()
        });
 
    }, [growthbook]);

  
    return <GBProvider growthbook={growthbook}>{children}</GBProvider >;
  };